import { Box } from "@mui/material";
import { Formik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  NEW_ENTRY_FIELDS,
  ORGANIZATION_STRUCTURE_FIELDS,
} from "../../contants/formFields";
import OrganizationStructure from "../common/OrganizationStructure/OrganizationStructure";

import AddRemarkForm from "../../pages/Remarks/AddRemarkForm/AddRemarkForm";
import IntroductionFormApi from "../../services/api/introductionForm";
// import { divPrimary, divSecondary, textFieldStyle, buttonStyle } from "./styles";
import Toast from "../common/Toast";
import AssignRequestForm from "./AssignRequestForm";

export const formValidation = (formData) => {
  if (!formData.areaId) {
    return "Area cannot empty!";
  }
  if (!formData.addressLine1) {
    return "Address cannot empty!";
  }
  if (!formData.mobileNumber) {
    return "Mobile number cannot be empty!";
  }
  return "";
};

function AssignTransferRequest({
  selectedItem,
  onFinalSubmit,
  pageType,
  refreshRemarks,
}) {
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(null);
  const getState = async () => {
    const response = await IntroductionFormApi.getStates();
    if (response?.data) {
      console.log(selectedItem, "selecteditem");
      const filteredState = response.data.filter((s) => {
        return s.stateId === Number(selectedItem.state);
      });
      if (filteredState.length > 0) {
        setState(filteredState[0].stateName);
        const filteredCity = filteredState[0].cities.filter((c) => {
          return c.cityId === Number(selectedItem.city);
        });
        if (filteredCity.length > 0) {
          setCity(filteredCity[0].cityName);
        }
      }
      console.log(filteredState, "state-city");
    }
  };

  useEffect(() => {
    getState();
  }, []);

  // useEffect(() => {
  //   if (city) {
  //     setFieldValue(NEW_ENTRY_FIELDS.CITY, city);
  //   }
  //   if (state) {
  //     setFieldValue(NEW_ENTRY_FIELDS.STATE, state);
  //   }
  // }, [city, state]);

  return (
    <Box sx={{ p: "1rem" }}>
      <Formik
        enableReinitialize
        initialValues={{
          [ORGANIZATION_STRUCTURE_FIELDS.REGION]:
            selectedItem?.targetOrganizationStructure?.targetOrgRegionId,
          [ORGANIZATION_STRUCTURE_FIELDS.ZONE]:
            selectedItem.targetOrganizationStructure?.targetOrgZoneId,
          [ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]:
            selectedItem.targetOrganizationStructure?.targetOrgClusterId,
          [ORGANIZATION_STRUCTURE_FIELDS.AREA]:
            selectedItem.targetOrganizationStructure?.targetOrgAreaId,
          [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]:
            selectedItem.targetOrganizationStructure?.targetOrgDistrictId,
          [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]:
            selectedItem.targetOrganizationStructure?.targetOrgChapterId,
          [NEW_ENTRY_FIELDS.ADDRESS_LINE_1]: selectedItem.addressLine1,
          // [NEW_ENTRY_FIELDS.ADDRESS_LINE_2]: selectedItem.addressLine2,
          [NEW_ENTRY_FIELDS.CITY]: city,
          [NEW_ENTRY_FIELDS.STATE]: state,
          [NEW_ENTRY_FIELDS.PINCODE]: selectedItem.pincode,
          [NEW_ENTRY_FIELDS.CONTACT_NUMBER]: selectedItem.mobileNumber,
          [NEW_ENTRY_FIELDS.EMAIL_ADDRESS]: selectedItem.emailId,
        }}
        onSubmit={(values) => {
          const dataToSend = { ...values };
          dataToSend[NEW_ENTRY_FIELDS.STATE] = selectedItem.state;
          dataToSend[NEW_ENTRY_FIELDS.CITY] = selectedItem.city;
          dataToSend.transferRequestId = selectedItem.transferId;
          const error = formValidation(dataToSend);
          if (error) {
            setShowToast({
              message: error,
              severity: "error",
            });
            return;
          }
          onFinalSubmit(dataToSend, selectedItem, navigate, setShowToast);
          // postData(values);
        }}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          setFieldValue,
          /* and other goodies */
        }) => (
          <Box
            style={{
              display: "flex",
            }}
          >
            <Box
              style={{
                width: "40%",
                padding: "1rem 1.6rem",
              }}
            >
              <OrganizationStructure
                values={values}
                handleChange={handleChange}
                errors={errors}
                setFieldValue={setFieldValue}
                isLoading={false}
              />
            </Box>

            <AssignRequestForm
              handleChange={handleChange}
              values={values}
              handleSubmit={handleSubmit}
              city={city}
              state={state}
              setFieldValue={setFieldValue}
            />
          </Box>
        )}
      </Formik>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
      <Box>
        <AddRemarkForm
          selectedItem={selectedItem}
          pageType={pageType}
          refreshRemarks={refreshRemarks}
        />
      </Box>
    </Box>
  );
}

const propTypes = {
  selectedItem: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  onFinalSubmit: PropTypes.func.isRequired,
  refreshRemarks: PropTypes.func.isRequired,
  pageType: PropTypes.string.isRequired,
};

AssignTransferRequest.propTypes = propTypes;

export default AssignTransferRequest;
